// @ts-ignore
import html from './fastlink-modal.template.html';

/**
 * @constructor
 */
export class FastlinkService {

  /**
   * @private
   * @type {ng.IWindowService}
   */
  _$window;

  /**
   * @private
   * @type {ng.ui.bootstrap.IModalService}
   */
  _$uibModal;

  /**
   * @param {ng.IWindowService} $window
   * @param {ng.ui.bootstrap.IModalService} $uibModal
   */
  constructor($window, $uibModal) {
    this._$window = $window;
    this._$uibModal = $uibModal;
  }

  /**
   * @param {import("../../types/api").V2.FetchFastlinkStrategy.Response} fastlinkInfo
   */
  openFastlink(fastlinkInfo) {
    if (fastlinkInfo.strategy == 'navigate') {
      this._$window.location.assign(fastlinkInfo.url);
      return;
    }

    const fastlinkApi = this._$window.fastlink;

    return this._$uibModal.open({
      template: html,
      size: 'md',
      controllerAs: '$ctrl',
      controller: ['$scope', '$uibModalInstance',
        /**
         * @param {ng.IScope} $scope
         * @param {ng.ui.bootstrap.IModalInstanceService} $uibModalInstance
         */
        function($scope, $uibModalInstance) {
          this.fastlinkLoaded = false;

          const ctrl = this;
          $uibModalInstance.rendered.then(_ => {
            // @ts-ignore
            fastlinkApi.open({
              fastLinkURL: fastlinkInfo.url,
              jwtToken: fastlinkInfo.token,
              params: fastlinkInfo.params,
              onSuccess: function (data) {
                $uibModalInstance.close(data);
              },
              onError: function (data) {
              },
              onExit: function (data) {
                $uibModalInstance.close();
              },
              onEvent: (data) => {
                if (!ctrl.fastlinkLoaded && data.fnToCall == "loadModule") {
                  $scope.$applyAsync((scope) => {
                    ctrl.fastlinkLoaded = true;
                  });
                }
              }
            },
            'container-fastlink');
          });
      }],
    }).result
      .catch(function(err) {
        console.warn("Error in Fastlink service: ", err);
      })
      .then(function(_) {
        // @ts-ignore
        fastlinkApi.close()

        return _;
      });
  }
}

export default FastlinkService;